export default __webpack_public_path__ + "static/media/Maya 9781408300312.6e36f227.jpg";